<div class="row">
	<div class="col-12">
		<div class="content-header">Model Management Form</div>
	</div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
	<div class="row">
		<div class="col-12">
			<div class="card">

				<div class="card-content">
					<div class="card-body">
						<div class="row">
							<div class="col-md">
								<form [formGroup]="modelForm">
									<fieldset class="form-group">
										<label for="name">Name<span class="required_field">*</span></label>
										<input type="text" class="form-control" formControlName="name"
											[(ngModel)]="jobModel.name" id="name" placeholder="Enter Name" 
											#name required >
										<div *ngIf="!rf.name.valid && (rf.name.dirty || rf.name.touched)" class="help-block mt-1 text-danger"> <i class="ft-alert-circle
									align-middle"></i> name is required!
										</div>
									</fieldset>
									<fieldset class="form-group">
										<label for="notes">Type<span class="required_field">*</span></label>
										<ng-select
											[items]="jobType_list"
											bindLabel="name"
											bindValue="id"
											placeholder="Select Type"
											[(ngModel)]="selected_job_type"
											[ngModelOptions]="{ standalone: true }"
											(change)="selectTypeId($event)" 
										>
										</ng-select>
									</fieldset>
									<fieldset class="mb-2" *ngIf="current_type !== 'project'">
										<label>Source<span class="required_field">*</span></label>
										<ng-select [items]="sourceList" bindLabel="displayname" bindValue="_id"
											placeholder="Select Source" [(ngModel)]="selected_source"
											[ngModelOptions]="{ standalone: true }" (change)="getSourceId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="mb-2" *ngIf="current_type !== 'project'">
										<label>Channel<span class="required_field">*</span></label>
										<ng-select [items]="channelList" bindLabel="name" bindValue="_id" placeholder="Select Channel"
											[(ngModel)]="selected_channel" [ngModelOptions]="{standalone: true}"
											(change)="getChangeChannelId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="mb-2" *ngIf="current_type === 'project'">
										<label>Project Source<span class="required_field">*</span></label>
										<ng-select [items]="project_source_list" bindLabel="displayname" bindValue="_id"
											placeholder="Select Project Source" [(ngModel)]="selected_source"
											[ngModelOptions]="{ standalone: true }" (change)="getSourceId($event)">
										</ng-select>
									</fieldset>
                                    <fieldset class="mb-2">
										<label>Project Tag<span class="required_field">*</span></label>
										<ng-select [items]="project_tags_list" bindLabel="name" bindValue="_id"
											placeholder="Select Project Tag" [(ngModel)]="selectedproject_tag"
											[ngModelOptions]="{ standalone: true }" (change)="selectProjectTagId($event)">
										</ng-select>
									</fieldset>
                                    <!-- <fieldset class="mb-2">
										<label>Checklist<span class="required_field">*</span></label>
										<ng-select [items]="check_list" bindLabel="name" bindValue="_id"
											placeholder="Select Checklist" [(ngModel)]="selectedchecklist"
											[ngModelOptions]="{ standalone: true }" (change)="selectChecklistId($event)">
										</ng-select>
									</fieldset> -->
                                    <fieldset class="mb-2">
										<label>Market Stage<span class="required_field">*</span></label>
										<ng-select [items]="market_stage_list" bindLabel="name" bindValue="_id" placeholder="Select Market Stage"
											[(ngModel)]="selected_market_stage" [ngModelOptions]="{standalone: true}"
											(change)="getMarketStageId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="mb-2">
										<label>Config State<span class="required_field">*</span></label>
										<ng-select [items]="config_state_list" bindLabel="name" bindValue="_id" placeholder="Select Config State"
											[(ngModel)]="selected_config_state" [ngModelOptions]="{standalone: true}"
											(change)="getConfigStateId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="mb-2">
										<label>Model Category<span class="required_field">*</span></label>
										<ng-select [items]="model_cat_list" bindLabel="name" bindValue="_id" placeholder="Select Model Category"
											[(ngModel)]="selected_model_cat" [ngModelOptions]="{standalone: true}"
											(change)="getModelCatId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="mb-2">
										<label>Model Source<span class="required_field">*</span></label>
										<ng-select [items]="model_source_list" bindLabel="name" bindValue="_id" placeholder="Select Model Source"
											[(ngModel)]="selected_model_source" [ngModelOptions]="{standalone: true}"
											(change)="getModelSourceId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="mb-2">
										<label>Model Varient<span class="required_field">*</span></label>
										<ng-select [items]="model_varient_list" bindLabel="name" bindValue="_id" placeholder="Select Model Varient"
											[(ngModel)]="selected_model_varient" [ngModelOptions]="{standalone: true}"
											(change)="getModelVarientId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="form-group">
										<label for="name">Code Name</label>
										<input type="text" class="form-control" formControlName="codename"
											[(ngModel)]="jobModel.codeName" id="name" placeholder="Enter Code Name" 
											 >
										<!-- <div *ngIf="!rf.name.valid && (rf.name.dirty || rf.name.touched)" class="help-block mt-1 text-danger"> <i class="ft-alert-circle
									align-middle"></i> name is required!
										</div> -->
									</fieldset>

									<fieldset class="mb-2" *ngIf="current_type !== 'project'">
										<label>Hunting By<span class="required_field">*</span></label>
										<ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Select Hunting"
											[(ngModel)]="selectedHuntingBy" [ngModelOptions]="{ standalone: true }" [multiple]="true"
											(change)="getHuntId($event)" #huntingBy="ngModel">
										</ng-select>
									</fieldset>
									<fieldset class="form-group" *ngIf="current_type !== 'project'">
										<label for="notes">Alert<span class="required_field">*</span></label>
										<ng-select
											[items]="alert_list"
											bindLabel="name"
											color="is_activated"
											bindValue="id"
											placeholder="Select Alert"
											[(ngModel)]="alert_event"
											[ngModelOptions]="{ standalone: true }"
											(change)="selectAlert($event)" 
										>
										</ng-select>
									</fieldset>
									<fieldset class="mb-2" *ngIf="current_type !== 'project'">
										<label>Engage Tags<span class="required_field">*</span></label>
										<ng-select [items]="engage_tags_list" bindLabel="displayname" bindValue="_id" placeholder="Select Hunting"
											[(ngModel)]="selected_engage_tags" [ngModelOptions]="{ standalone: true }"(change)="getEngageId($event)">
										</ng-select>
									</fieldset>
								</form>
							</div>
							<div class="col-md">

								<form [formGroup]="modelForm">
									<fieldset class="form-group" *ngIf="current_type !== 'project'">
										<label for="projectbudget">Project Budget<span class="required_field">*</span></label>
										<input type="text" class="form-control" formControlName="projectbudget"
											id="projectbudget" [(ngModel)]="jobModel.projectbudget"
											placeholder="Enter project budget" required #projectbudget>
										<div *ngIf="rf.projectbudget.touched && (rf.projectbudget.invalid ||
								rf.projectbudget.errors?.required)" class="help-block mt-1 text-danger"> <i class="ft-alert-circle
									align-middle"></i> project budget is required!
										</div>
									</fieldset>
									<fieldset class="form-group" *ngIf="current_type !== 'project'">
										<label for="rate">Rate<span class="required_field">*</span></label>
										<input type="text" class="form-control" formControlName="rate" id="rate"
											[(ngModel)]="jobModel.rate" placeholder="Enter rate" required #rate>
										<div *ngIf="rf.rate.touched && (rf.rate.invalid ||
											rf.rate.errors?.required)" class="help-block mt-1 text-danger"> <i class="ft-alert-circle
												align-middle"></i> rate is required!
										</div>
									</fieldset>
									<fieldset class="mb-2">
										<label>Technology<span class="required_field">*</span></label>
										<ng-select [items]="technology_List" bindLabel="displayname" bindValue="_id"
											placeholder="Select Technology" [(ngModel)]="selectedTechnology"
											[ngModelOptions]="{ standalone: true }" (change)="getTechnologyId($event)">
										</ng-select>
									</fieldset>
                                    <fieldset class="mb-2">
										<label>Owner<span class="required_field">*</span></label>
										<ng-select [items]="usersList" bindLabel="name" bindValue="_id"
											placeholder="Select Owner" [(ngModel)]="selectedowner"
											[ngModelOptions]="{ standalone: true }" (change)="selectOwnerId($event)">
										</ng-select>
									</fieldset>
                                    <fieldset class="mb-2">
										<label>Auditor<span class="required_field">*</span></label>
										<ng-select [items]="usersList" bindLabel="name" bindValue="_id"
											placeholder="Select Auditor" [(ngModel)]="selectedauditor"
											[ngModelOptions]="{ standalone: true }" (change)="selectAuditorId($event)">
										</ng-select>
									</fieldset>
                                    <fieldset class="mb-2">
										<label>Publisher<span class="required_field">*</span></label>
										<ng-select [items]="usersList" bindLabel="name" bindValue="_id"
											placeholder="Select Publisher" [(ngModel)]="selectedpublisher"
											[ngModelOptions]="{ standalone: true }" (change)="selectPublisherId($event)">
										</ng-select>
									</fieldset>
                                    <fieldset class="mb-2">
										<label>Marketer<span class="required_field">*</span></label>
										<ng-select [items]="usersList" bindLabel="name" bindValue="_id"
											placeholder="Select Marketer" [(ngModel)]="selectedmarketer"
											[ngModelOptions]="{ standalone: true }" (change)="selectMarketerId($event)">
										</ng-select>
									</fieldset>
									<fieldset class="mb-2">
										<label>Reference<span class="required_field">*</span></label>
											<ng-select [items]="referenceList" bindLabel="name" [multiple]="true" [closeOnSelect]="false"
												bindValue="_id" placeholder="Select References" 
												[(ngModel)]="selectedRef" [ngModelOptions]="{ standalone: true }" 
												(change)="getRefId($event)">
												<ng-template ng-header-tmp>
													<div class="btn btn-link" (click)="openModal(myModal)">
														Add New Reference
													</div>
												</ng-template>
												<ng-template ng-option-tmp let-item="item">
													<span>{{ item.name }}</span><span>&nbsp;&nbsp;&nbsp;</span>
													<i *ngIf="item.id === selectedItemId && item.job_id" class="fa fa-edit" (click)="editItem(item,myModal2)"></i>&nbsp;&nbsp;
													<i *ngIf="item.id === selectedItemId && item.job_id" class="fa fa-trash" (click)="confirmDelete(item._id)"></i>
												</ng-template>
											</ng-select>
									</fieldset>
									<fieldset class="mb-2" *ngIf="current_type !== 'project'">
										<label>Farming<span class="required_field">*</span></label>
											<ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Select Farming"
												[(ngModel)]="selectedFarmingBy" [ngModelOptions]="{ standalone: true }" [multiple]="true"
												(change)="getFarmId($event)" #farmingBy="ngModel">
											</ng-select>
									</fieldset>
									<fieldset class="mb-2">
										<label>Skills<span class="required_field">*</span></label>
											<ng-select [items]="tagsList" bindLabel="displayname" bindValue="_id" placeholder="Select Skills"
												[(ngModel)]="selectedSkill" [ngModelOptions]="{ standalone: true }" [multiple]="true"
												(change)="getTagsId($event)" #farmingBy="ngModel">
											</ng-select>
									</fieldset>
									<fieldset class="form-group" *ngIf="current_type === 'project'">
										<label for="notes">Alert<span class="required_field">*</span></label>
										<ng-select
											[items]="alert_list"
											bindLabel="name"
											color="is_activated"
											bindValue="id"
											placeholder="Select Alert"
											[(ngModel)]="alert_event"
											[ngModelOptions]="{ standalone: true }"
											(change)="selectAlert($event)" 
										>
										</ng-select>
									</fieldset>
									
								</form>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<form [formGroup]="modelForm">
									<fieldset class="form-group">
										<label for="notes">Alert Notes</label>
										<quill-editor (onContentChanged)="setFocus($event,'alert_notes')"formControlName="alert_notes" [(ngModel)]="jobModel.alert_notes"></quill-editor>

									</fieldset>
									<fieldset class="form-group">
										<label for="notes">Process Notes</label>
										<quill-editor (onContentChanged)="setFocus($event,'notes')"formControlName="notes" [(ngModel)]="jobModel.notes"></quill-editor>

									</fieldset>
									<fieldset class="form-group">
										<label for="description">Description</label>
										<quill-editor (onContentChanged)="setFocus($event,'description')"formControlName="description" [(ngModel)]="jobModel.description"></quill-editor>

									</fieldset>
									<fieldset class="form-group">
										<label for="description">Feature</label>
										<quill-editor (onContentChanged)="setFocus($event,'feature')"formControlName="feature" [(ngModel)]="jobModel.feature"></quill-editor>

									</fieldset>
									<fieldset class="form-group">
										<label for="admin_notes">Credentials & Admin Notes</label>
										<quill-editor (onContentChanged)="setFocus($event,'admin_notes')"formControlName="admin_notes" [(ngModel)]="jobModel.admin_notes"></quill-editor>

									</fieldset>
                                    <fieldset class="form-group">
										<label for="admin_notes">Domain</label>
										<quill-editor (onContentChanged)="setFocus($event,'domain')"formControlName="domain" [(ngModel)]="jobModel.domain"></quill-editor>
									</fieldset>
									<fieldset class="form-group">
										<label for="admin_notes">Config Notes</label>
										<quill-editor (onContentChanged)="setFocus($event,'config_notes')"formControlName="config_notes" [(ngModel)]="jobModel.config_notes"></quill-editor>
									</fieldset>
									<fieldset class="form-group">
										<label for="admin_notes">Demo Notes</label>
										<quill-editor (onContentChanged)="setFocus($event,'demo_notes')"formControlName="demo_notes" [(ngModel)]="jobModel.demo_notes"></quill-editor>
									</fieldset>
									<div>
										<h5 *ngIf="!jobModel.image">Select Image Upload Type</h5>
										<h5 *ngIf="jobModel.image">Image Uploaded Type</h5>

									
										<button *ngIf="!jobModel.image" class="btn btn-primary btn-sm mx-1" (click)="switchUploadType('single')">Single Image Upload</button>
										<button *ngIf="!jobModel.image" class="btn btn-primary btn-sm mx-1" (click)="switchUploadType('multiple')">Multiple Image Upload</button>
									
										<!-- Single Image Upload -->
										<div *ngIf="!jobModel.image && selectedUploadType == 'single'">
											<h5 class="mt-2">Upload a Single Image</h5>
											<input type="file" accept="image/*" (change)="onSingleFileSelected($event)" />
											<div *ngIf="selectedImage">
												<img [src]="selectedImage" alt="Selected Image" width="200" />
											</div>
										</div>
										<div *ngIf="jobModel?.image">
											<img [src]="base_url+jobModel?.image" alt="img" width="200">
										</div>
									
										<!-- Multiple Image Upload -->
										<div *ngIf="selectedUploadType == 'multiple'">
											<h5 class="mt-2">Upload Multiple Images</h5>
											<input type="file" accept="image/*" (change)="onMultipleFilesSelected($event)" multiple />
											<div *ngIf="selectedImages.length > 0">
												<h4>Selected Images:</h4>
												<div *ngFor="let image of selectedImages">
													<h5>{{ image.name }}</h5>
													<img [src]="image.name" alt="Selected Image" width="200" />
												</div>
											</div>
										</div>
									</div>

								</form>
							</div>
							<div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
								<button [disabled]="modelForm.invalid" type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
									(click)="submit()">Submit</button>
								<button type="reset" class="btn btn-secondary" (click)="back()">Cancel</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-------------- Add Reference Popup ------------------------------------------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Add Reference</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form [formGroup]="referenceForm">
				<div class="form-group">
					<label>Name</label>
					<input type="text" class="form-control" formControlName="name" [(ngModel)]="reference_model.name">
				</div>
				<div class="form-group">
					<label>Link</label>
					<input type="text" class="form-control" formControlName="links" [(ngModel)]="reference_model.links">
				</div>
				<div class="form-group">
					<label>Description</label>
					<textarea class="form-control" formControlName="description" [(ngModel)]="reference_model.description" name="notes" id="notes" cols="30"
						rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Notes</label>
					<textarea class="form-control" formControlName="notes" [(ngModel)]="reference_model.notes" name="notes" id="notes" cols="30"
						rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Admin Notes</label>
					<textarea class="form-control" formControlName="admin_notes" [(ngModel)]="reference_model.admin_notes" name="notes" id="notes" cols="30"
						rows="2"></textarea>
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="submitRef()">Submit</button>
		  </div>
	</ng-template>
</div>
<!-------------- Edit Reference Popup ------------------------------------------->
<div>
	<ng-template #myModal2 let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Update Reference</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form [formGroup]="referenceForm">
				<div class="form-group">
					<label>Name</label>
					<input type="text" class="form-control" [(ngModel)]="reference_model.name"  [ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Link</label>
					<input type="text" class="form-control" [(ngModel)]="reference_model.links"  [ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Description</label>
					<textarea class="form-control" [(ngModel)]="reference_model.description"  [ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30"
						rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Notes</label>
					<textarea class="form-control" [(ngModel)]="reference_model.notes"  [ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30"
						rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Admin Notes</label>
					<textarea class="form-control" [(ngModel)]="reference_model.admin_notes"  [ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30"
						rows="2"></textarea>
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="updateRef()">Update</button>
		  </div>
	</ng-template>
</div>